// Admin do canal ScontiPoste
const adminChannelDictES = {
  adminChannelMenu: "ScontiPoste",
  adminChannelTabConfig: "Configuración",
  adminChannelTabSellers: "Managers",
  adminChannelTabSales: "Ventas",
  adminChannelTabCashback: "Provisión de cashback",
  adminChannelUrl: "Enlace del escaparate",
  adminChannelUrlHelp: "Es el enlace que publica ScontiPoste. Para saber de dónde vienen las ventas, comparte el enlace con UTM.",
  adminChannelUtmUrl: "Enlace con UTM",
  adminChannelOpen: "Abrir escaparate",
  adminChannelStatus: "Estado",
  adminChannelActive: "Escaparate abierto al público",
  adminChannelInactive: "Escaparate cerrado",
  adminChannelPercent: "Cashback ScontiPoste (%)",
  adminChannelPercentHelp: "Se descuenta al vendedor en cada venta. Solo vale para pedidos nuevos.",
  adminChannelSave: "Guardar",
  adminChannelSaved: "Configuración guardada",
  adminChannelActiveSellers: "Managers activos: {count}",
  adminChannelOutdated: "{count} Manager(s) aún no han aceptado el % actual: sus productos están fuera del escaparate.",
  adminChannelConfirmPercentTitle: "¿Cambiar el cashback?",
  adminChannelConfirmPercent: "El cashback pasa del {from}% al {to}%. Los {count} Managers activos deben aceptar el nuevo % en su panel; hasta entonces sus productos salen del escaparate.",
  adminChannelConfirmPercentAction: "Cambiar a {to}%",
  adminChannelSeller: "Manager",
  adminChannelJoined: "Adhesión",
  adminChannelTermsPercent: "% aceptado",
  adminChannelProductsMode: "Productos",
  adminChannelAllProducts: "Toda la tienda",
  adminChannelSelectedProducts: "Seleccionados",
  adminChannelListed: "En el escaparate",
  adminChannelSellerStatus: "Estado",
  adminChannelStatusActive: "Activo",
  adminChannelStatusOutdated: "Aceptación pendiente",
  adminChannelStatusLeft: "Fuera del canal",
  adminChannelSuspend: "Suspender",
  adminChannelReactivate: "Reactivar",
  adminChannelSuspendTitle: "¿Suspender al Manager?",
  adminChannelSuspendConfirm: "Los productos de {name} salen del escaparate ScontiPoste al momento. Los pedidos ya hechos siguen con normalidad.",
  adminChannelSearchSellers: "Buscar Manager",
  adminChannelFrom: "Desde",
  adminChannelTo: "Hasta",
  adminChannelApply: "Filtrar",
  adminChannelCheckout: "Checkout",
  adminChannelDate: "Fecha",
  adminChannelBuyer: "Comprador",
  adminChannelOrders: "Pedidos",
  adminChannelTotal: "Total",
  adminChannelOrigin: "Origen",
  adminChannelNoOrigin: "Sin UTM",
  adminChannelCheckoutPAID: "Pagado",
  adminChannelCheckoutCREATED: "No completado",
  adminChannelCheckoutFAILED: "Fallido",
  adminChannelCheckoutREFUNDED: "Reembolsado",
  adminChannelCheckoutPARTIALLY_REFUNDED: "Reembolso parcial",
  adminChannelPaidTotal: "Total pagado en el periodo: {total}",
  adminChannelSearchSales: "Buscar comprador, pedido o campaña",
  adminChannelCashbackHelp: "Cashback descontado a los vendedores al recibir los pedidos. Sirve para revisar la factura de Poste Italiane.",
  adminChannelCashbackTotal: "Total provisionado en el periodo: {total}",
  adminChannelExportCsv: "Exportar CSV",
  adminChannelBySeller: "Por Manager",
  adminChannelOrder: "Pedido",
  adminChannelAmount: "Importe",
  adminChannelOrderAmount: "Valor de los productos",
  adminChannelSearchCashback: "Buscar Manager o pedido",
  adminChannelEntryACCRUED: "Provisionado",
  adminChannelEntryREVERSED: "Anulado",
  channelError500439: "El cashback debe estar entre 0 y 100, con hasta 2 decimales.",
  channelError500440: "Define un cashback mayor que 0 antes de abrir el escaparate.",
};

export default adminChannelDictES;
